export const handleChangeDataPageSearch = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_SEARCH', name, value
});